import React from 'react';
import { useTranslation } from 'react-i18next';

import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const BudgetCommonFilter = (props) => {
  const { params, getParam, categoryList, initialization } = props;
  const { t } = useTranslation();
  return (
    <>
      <NewCommonFilter
        initialization={initialization}
        getParam={getParam}
        params={params}
        useDate={!!params.isPop && !params.type}
        useDisplayFilter={false}
        usePltfomTpCodeFilter={false}
        useExternalFilter={false}
      />
      {params['type'] !== 'targeting' && (
        <FilterCollection
          label={t('카테고리')}
          name="ctgrSeqs"
          params={params}
          value={params.ctgrSeqs}
          type="checkbox"
          list={categoryList}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
          popoverWidth={640}
        />
      )}
      <FilterCollection
        label={t('기준')}
        name="stdCode"
        params={params}
        value={params.stdCode}
        type="radio"
        list={[
          { label: t('전환율'), value: '01' },
          { label: t('클릭율'), value: '02' },
        ]}
        callBack={getParam}
        labelKey="label"
        valueKey="value"
      />
    </>
  );
};

export default BudgetCommonFilter;
